import { createFeatureFlags } from './create-feature-flags';
import { buildConfig, parseForceEnabled } from './env-config';
import { FeatureFlag } from './flags';
import { createUnleashClient } from './unleash-client';

// A literal `import.meta.env.DEV` check, so Vite eliminates the override path
// from production bundles entirely rather than shipping a disabled branch.
const overrides = import.meta.env.DEV
  ? parseForceEnabled(import.meta.env.VITE_UNLEASH_FORCE_ENABLED)
  : undefined;

// NOTE: this runs at import time — importing `@/feature-flags` anywhere, unit
// tests included, calls `buildConfig`. That is only harmless because every
// committed `.env` leaves VITE_UNLEASH_URL/VITE_UNLEASH_CLIENT_KEY blank, so
// the config is null and no client is constructed. Putting a real URL in
// `.env.local-dev` would turn every unit test into a network caller; supply
// local credentials through the untracked `.env.local-dev.local` instead.
const featureFlags = createFeatureFlags({
  flags: FeatureFlag,
  loadConfig: () => buildConfig(import.meta.env),
  createClient: createUnleashClient,
  overrides,
});

export const {
  FeatureFlagProvider,
  FeatureFlagGate,
  useFeatureFlag,
  useFeatureFlagsReady,
  identify,
} = featureFlags;

// Vite can re-evaluate this module without a full reload, which would start a
// second polling client and orphan the first. Dev-only; stripped from prod.
import.meta.hot?.dispose(() => featureFlags.dispose());
